import Icon from "./IconBase.js";
const TrashIcon = (props) => {
  return (
    <Icon width="24" height="24" viewBox="0 0 24 24" {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.7871 5.24297C21.1761 5.24297 21.5 5.56596 21.5 5.97696V6.35696C21.5 6.75795 21.1761 7.09095 20.7871 7.09095H4.21385C3.82386 7.09095 3.5 6.75795 3.5 6.35696V5.97696C3.5 5.56596 3.82386 5.24297 4.21385 5.24297H7.12957C7.72185 5.24297 8.2373 4.82197 8.37054 4.22798L8.52323 3.54598C8.76054 2.61699 9.5415 2 10.4353 2H14.5647C15.4488 2 16.2385 2.61699 16.467 3.49699L16.6304 4.22698C16.7627 4.82197 17.2781 5.24297 17.8714 5.24297H20.7871ZM19.3058 19.134C19.6102 16.2971 20.1432 9.55712 20.1432 9.48913C20.1626 9.28313 20.0955 9.08813 19.9623 8.93113C19.8193 8.78413 19.6384 8.69713 19.4391 8.69713H5.56852C5.36818 8.69713 5.17756 8.78413 5.04529 8.93113C4.91108 9.08813 4.84494 9.28313 4.85467 9.48913C4.85646 9.50162 4.87558 9.73903 4.90755 10.1359C5.04958 11.8992 5.44517 16.8102 5.70079 19.134C5.88168 20.846 7.00498 21.922 8.63206 21.961C9.88763 21.99 11.1811 22 12.5038 22C13.7496 22 15.0149 21.99 16.3094 21.961C17.9929 21.932 19.1152 20.875 19.3058 19.134Z"
          fill="#E7685A"
        />
      </svg>
    </Icon>
  );
};
export default TrashIcon;
